export default "__VITE_ASSET__477e5839__"